<ef-process-detail [process]="process$ | async"></ef-process-detail>
<ef-loading [loading]="loading"></ef-loading>
<div class="card">
    <ef-send-invoice-filter
        (Filter)="onFilter($event)"
        [startDate]="(userInfo$ | async)?.PrevPayPeriodStart"
        [endDate]="(userInfo$ | async)?.PrevPayPeriodEnd"
    ></ef-send-invoice-filter>
    <ef-send-invoice-presenter
        [selectedError]="selectedErrorWithStatus$ | async"
        [items]="SendInvoiceModelDS.entities$ | async"
        (SendInvoices)="onSendInvoices($event)"
    ></ef-send-invoice-presenter>
</div>

